import { EntityList } from '@/common/entityFramework/entityList/EntityList'
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useCallback } from 'react';

export const ProdPriceList = ({ ndc11ProdId }) => {
  
  const augRowsReq = useCallback((rowsReq) => {
    if (!ndc11ProdId) return;
    rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('prodId', ndc11ProdId));
  }, [ndc11ProdId]);

  return (
    <EntityList entity="PROD_PRICE" augRowsReq={augRowsReq}/>
  )
}
